<template>
  <div class="">
    <div class="mobile">
      <div class="header">
        <p class="title">
          <i class="menuIcon el-icon-s-unfold" @click="showDrawer"></i>
          昌恩暖通智控节能项目投资回报预算列表
        </p>
        <!-- <p class="newBudget">新增预算</p> -->
        <el-button class="newBudget" type="primary" @click="newBudget"
          >新增预算</el-button
        >
      </div>

      <el-dialog
        append-to-body
        title="新建预算"
        :visible.sync="dialogVisible"
        width="90%"
        :before-close="handleClose"
        class="custom-dialog"
      >
        <el-form :model="projectForm" ref="projectForm" class="custom-from">
          <el-form-item
            label="预算名称："
            required
            :rules="[
              { required: true, message: '请输入预算名称', trigger: 'blur' }
            ]"
            prop="projectName"
          >
            <el-input
              placeholder="请输入预算名称"
              v-model="projectForm.projectName"
            ></el-input>
          </el-form-item>
        </el-form>
        <!--  -->
        <span slot="footer" class="dialog-footer">
          <el-button class="cancel-btn" @click="colseDialog">取 消</el-button>
          <el-button type="primary" @click="confirmDialog">确 定</el-button>
        </span>
      </el-dialog>

      <el-card class="box-card set-scroll">
        <el-table
          :data="tableData"
          style="width: 100%"
          @row-click="clickControl"
        >
          <!-- <el-table-column type="index" width="60"> </el-table-column> -->
          <el-table-column label="序号" width="70">
            <template slot-scope="scope">
              {{
                scope.$index + 1 + (pageData.pageNum - 1) * pageData.pageSize
              }}
            </template>
          </el-table-column>

          <!-- <el-table-column prop="date" label="日期" width="160">
          </el-table-column> -->
          <el-table-column prop="name" label="名称" width="180">
          </el-table-column>
          <el-table-column
            prop="HVAC_EnergyConsumption_Annual"
            label="项目暖通系统年用电量"
            width="280"
          >
          </el-table-column>
          <el-table-column
            prop="HVAC_AveragePSR_Annual"
            label="年均节能率"
            width="160"
          >
          </el-table-column>

          <el-table-column
            prop="HVAC_PowerSavings_Annual"
            label="年均节电量"
            width="160"
          >
          </el-table-column>

          <el-table-column
            prop="HVAC_PowerSavings_Monthly"
            label="月均节电量"
            width="180"
          >
          </el-table-column>

          <el-table-column prop="Power_UnitPrice" label="电费单价" width="180">
          </el-table-column>

          <el-table-column
            prop="HVAC_Savings_Total"
            label="项目年均总节电费"
            width="260"
          >
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageData.pageNum"
          :page-sizes="[100, 200, 300, 400]"
          :page-size="pageData.pageSize"
          layout="total, prev, pager, next,jumper"
          :total="totalPage"
        >
        </el-pagination>
      </el-card>
    </div>
    <!-- 菜单抽屉 -->
    <menuDrawer
      :drawerVisible="drawerVisible"
      @closeDrawer="closeDrawer"
    ></menuDrawer>
  </div>
</template>

<script>
import menuDrawer from '@/views/mobile/components/menuDrawer.vue'
import { getOffer } from '@/api/home/index'
export default {
  components: { menuDrawer },
  data () {
    return {
      getLoginUser: JSON.parse(localStorage.getItem('userInfo')).userName,
      dialogVisible: false,
      projectForm: { projectName: '' },
      tableData: [],
      totalPage: 0,
      pageData: {
        userName: JSON.parse(localStorage.getItem('userInfo')).userName,
        pageSize: 12,
        pageNum: 1
      },
      drawerVisible: false
    }
  },
  mounted () {
    this.initData(this.pageData)
  },
  methods: {
    async initData (page) {
      try {
        const res = await getOffer(page)
        this.tableData = res.data.data
        this.totalPage = res.data.total
        console.log('列表', res.data.data)
      } catch (error) {}
    },

    // 弹框
    newBudget () {
      this.dialogVisible = true
    },
    handleClose () {
      this.dialogVisible = false
      this.$refs.projectForm.resetFields()
    },
    confirmDialog () {
      this.$refs.projectForm.validate(valid => {
        if (valid) {
          this.dialogVisible = false
          this.$router.push({
            path: 'budgetSheet',
            query: {
              name: this.projectForm.projectName
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    colseDialog () {
      this.dialogVisible = false
      this.$refs.projectForm.resetFields()
    },

    clickControl (row) {
      console.log('点击项id', row.id)
      this.$router.push({
        path: 'budgetSheet',
        query: {
          id: row.id,
          title: 1
        }
      })
    },
    handleSizeChange () {},
    handleCurrentChange (page) {
      this.pageData.pageNum = page
      this.initData(this.pageData)
      console.log('选择页码', page)
    },

    // 抽屉
    showDrawer () {
      this.drawerVisible = true
    },
    closeDrawer () {
      this.drawerVisible = false
    }
  }
}
</script>

<style lang="less" scoped>
// .container {
//     height: calc(100% - 70px);
//     padding: 10px 16px;
// }
.mobile {
  .header .title {
    margin: 20px 20px 20px 0;
    padding-bottom: 10px;
    text-align: left;
    color: rgba(@homeBoxColor, 0.9);
    font-weight: 700;
    font-size: 5em;
    padding: 60px 60px 60px 0;
    display: flex;
    align-items: center;
    .menuIcon {
      font-size: 1.8em;
      margin-right: 0.5em;
    }
  }

  .newBudget {
    width: 100%;
    margin: 0 auto;
    font-size: 6em;
    margin-bottom: 0.5em;
    border-radius: 0.1em;
    padding: 0.5em;
  }
  .box-card {
    height: calc(100vh - 580px);
    // height: calc(100vh - 600px);
    overflow: auto;
  }
  ::v-deep .cell {
    font-size: 2em;
    padding: 1.5em 0.6em;
  }

  ::v-deep .el-table .el-table__cell {
    font-size: 2.5em;
  }

  .el-pagination {
    width: 100%;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 4em;
    margin-bottom: 4em;

    ::v-deep .el-pagination__total,
    ::v-deep .btn-next .el-icon,
    ::v-deep .btn-prev .el-icon,
    ::v-deep .el-pagination__jump {
      font-size: 4em;
    }

    ::v-deep .el-pager li {
      font-size: 76px;
      font-weight: normal;
      height: 76px;
      line-height: 76px;
    }
    ::v-deep .btn-prev,
    ::v-deep .btn-next {
      font-size: 1.3em;
      display: flex;
      align-items: center;
      height: auto;
    }
    ::v-deep .el-pagination__jump {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 8em;
    }
    ::v-deep .el-pagination__editor.el-input {
      width: 16em;
    }
    ::v-deep .el-input__inner {
      color: orange;
      font-size: 5em;
      padding: 0.6em 0.2em;
      width: 2em;
      height: 1em;
      margin-top: -0.5em;
    }
  }
}
</style>

<style lang="less">
.mobile .dialog-batch .el-dialog__body {
  max-height: none;
  padding: 6em;
}

.custom-dialog {
  .el-dialog__header {
    border-bottom: 2px solid #ccc;
    padding: 3em;
    .el-dialog__title {
      font-size: 5em;
      line-height: 1;
    }
  }
  .el-dialog__body {
    padding: 10em 0;
  }
  .el-dialog__footer {
    padding: 2em;
  }
}

.custom-from {
  .el-form-item__label {
    font-size: 5em;
    width: 7em;
  }
  .el-input__inner {
    font-size: 5em;
    padding: 0.8em 0.5em;
  }
  .el-form-item {
    display: flex;
    align-items: center;
    justify-content: start;
  }
  .el-form-item__content {
    margin-right: 2em;
    flex: 1;
  }
  .el-form-item__error {
    font-size: 5em;
  }
}

.dialog-footer {
  .el-dialog__footer {
    text-align: center !important;
  }
  .el-button {
    font-size: 4em;
    padding: 0.6em;
    border-radius: 0.2em;
    margin: 0.6em;
  }
  .cancel-btn {
    margin-right: 1em;
  }
}
</style>
